import { useLocation } from 'react-router';

import { EmailContextProvider } from '../contexts/EmailContext';
import { EmailForm } from '../components/form/forms/emailForms/EmailForm';
import { SearchListClients } from '../components/form/search/clients/SearchListClients';
import { Container } from '../layouts/Container';

import { baseFields, emailFieldNames } from '../lib/mocks/email-mock';

export const mockClientId = [
  {
    id: 1,
    placeholder: 'Client',
    fieldType: 'search',
    name: emailFieldNames.client_id,
    classNames: 'w-full sm:w-2/4',
    searchComponent: SearchListClients,
  },
];

export const Emails = () => {
  const { state } = useLocation();

  return (
    <Container>
      <div className="flex flex-col gap-4 w-full">
        <div>
          <h2 className="text-lg font-bold color-blackColor">Recepients</h2>
        </div>

        <EmailContextProvider
          initialRealty={state?.realty ?? null}
          requestId={state?.requestId ?? null}
        >
          <EmailForm
            initialClientId={state?.clientId ?? null}
            inputs={[...mockClientId, ...baseFields]}
          />
        </EmailContextProvider>
      </div>
    </Container>
  );
};
